import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  shadows: {
    profile: "0px 2px 8px -2px rgba(0,0,0,.1)",
    banner: "0px 2px 10px -4px rgba(0,0,0,.16)",
    item: "0px 2px 10px -4px rgba(0,0,0,0.1)",
    tab: "0px 2px 10px -4px rgba(0,0,0,.05)",
    nav: "0px -2px 10px -4px rgba(0,0,0,.05)",
    card: "0px 2px 10px -4px rgba(232,232,232,.1)",
  },

  gradients: {
    banner1: "linear-gradient(#FFD941 0%, #FFD62E 8%, #FFCD11 100%)",
    banner2:
      "linear-gradient(#EE8600 0%, #EE8800 12%, #EE8000 23%, #EE7E00 39%, #F26700 100%)",
    growLearn: "linear-gradient(135deg, #F58415 0%, #FAA514 73%, #FEC01A 100%)",
  },

  colors: {
    // Colors
    primary100: "#FE570B",
    primary100Hover: "#F54107",
    primary100Shade: "#FFE9DF",
    primary38: "#FE570B61",
    primary20: "#FE570B33",
    primary10: "#FE570B19",
    primary5: "#FE570B0d",
    secondary100: "#00BD4E",
    secondary100Hover: "#00A544",
    secondary100Shade: "#E4FFEF",
    secondary10: "#00BD4E19",
    tertiary100: "#FEC901",
    tertiary100Hover: "#FEBB01",
    tertiary100Shade: "#FFF9E3",
    destructive100: "#E93416",

    // Basics
    white100: "#ffffff",
    white100Hover: "#FFF9E4",
    white90: "#ffffffe6",
    white80: "#ffffffcc",
    white70: "#ffffffb3",
    white60: "#ffffff99",
    white38: "#ffffff61",
    white12: "#ffffff1f",
    black100: "#000000",
    black90: "#000000e6",
    black80: "#000000cc",
    black70: "#000000b3",
    black60: "#00000099",
    black50: "#00000080",
    black40: "#00000066",
    black38: "#00000061",
    black30: "#0000004C",
    black20: "#00000033",
    black12: "#0000001f",
    black10: "#00000019",
    black8: "#00000014",
    black5: "#0000000d",
    black4: "#00000004",
    black2: "#00000005",
    gray100: "#E8E8E8",
    gray100Hover: "#DBDBDB",

    // Tag color
    tagBlue100: "#188CED",
    tagBlue20: "#188CED33",
    tagSkyBlue100: "#00B2EA",
    tagSkyBlue20: "#00B2EA33",
    tagPurple100: "#775EC2",
    tagPurple20: "#775EC233",
    tagOrange100: "#FF9E02",
    tagOrange20: "#FF9E0233",
    tagYellow100: "#FFCE1F",
    tagYellow20: "#FFCE1F33",
    tagGreen100: "#00BD4E",
    tagGreen20: "#00BD4E33",
    tagPink100: "#FF6C93",
    tagPink20: "#FF6C9333",

    // Learning Category
    blockTheme: "#FEC901",
    artTheme: "#7860C3",
    hangeulTheme: "#00BD4E",
    englishTheme: "#188CED",
    mathTheme: "#FF641E",
    codingTheme: "#FF9E02",

    hangeulThemeHover: "#008f3cff",
    englishThemeHover: "#025294ff",
    mathThemeHover: "#ba4b18ff",

    // Carousel Color
    carousel1: "#00BD4E",
    carousel2: "#188CED",
    carousel3: "#FEC901",
    carousel4: "#FE570B",
    carousel5: "#7860C3",

    // SNS
    kakao: "#F9E000",
    kakaoHover: "#F9D200",
    naver: "#03CF5D",
    naverHover: "#1EC065",
    apple: "#181818",
    appleHover: "#000000",

    // Scrollbar
    scrollbar: "#0000004c",

    // Component
    introBg: "#F3F4F6",
    mainBg: "#F3F4F6",
    tabListBg: "#F7F6F266",
    boardTabListBg: "#E3E6EC",
    cardBg: "#F7F6F2",
  },
};
